module.exports = __webpack_public_path__ + "static/assets/9c00403d4720ace27a9fe94930d0bd1c.svg";